"use client";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
} from "@mui/material";
import React from "react";
import { ButtonComponent, SnackbarComponent } from "@/components";
import { Download } from "@mui/icons-material";
import checkPopup from "@/lib/hooks/popupChecker";
import { useGetLoanAgreementQuery } from "@/lib/redux";
import { WEB_COLORS } from "@/lib/constants";
import { useTranslations } from "next-intl";

export default function VerticalStepper({ loanData, appId }) {
  const t = useTranslations("Dashboard");
  const agreementDone = loanData?.some(
    (step) =>
      step?.label === "Agreement" &&
      step?.status?.toLowerCase() === "completed",
  );
  const { data: agreementData } = useGetLoanAgreementQuery(
    { appId },
    { skip: !appId || !agreementDone },
  );
  const activeProgressStep = loanData?.findIndex(
    (step) => step?.status?.toLowerCase() === "inprogress"
  );
  const activeCompletedStep =
    loanData?.findLastIndex(
      (step) => step?.status?.toLowerCase() === "completed"
    ) + 1;

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stepper
        activeStep={
          activeProgressStep > 0 ? activeProgressStep : activeCompletedStep
        }
        orientation="vertical"
      >
        {loanData?.map(
          ({ id, description, label, status, url, createdDate }) => (
            <Step key={id} expanded>
              <StepLabel
                sx={{
                  fontWeight: "bold",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {t(label?.replaceAll(" ", "")?.toLowerCase())}{" "}
                <span style={{ color: WEB_COLORS.textFadeColor, fontSize: 8 }}>
                  {createdDate && `(${createdDate})`}
                </span>
              </StepLabel>
              <StepContent>
                <Typography sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>{description}</Typography>

                {label === "Agreement" && status === "Completed" ? (
                  <>
                    <ButtonComponent
                      onClick={() => {
                        if (agreementData?.data?.LOAN_AGREEMENT) {
                          checkPopup(agreementData?.data?.LOAN_AGREEMENT);
                        } else {
                          SnackbarComponent({
                            error: true,
                            errorMessage: "Sanction letter not available",
                          });
                        }
                      }}
                      endIcon={<Download />}
                      buttonStyle={{ 
                        my: 1,
                        fontSize: 'clamp(0.75rem, 2vw, 1rem)',
                        padding: 'clamp(0.5rem, 1.5vw, 0.75rem) clamp(1rem, 3vw, 1.5rem)'
                      }}
                    >
                      {t("downloadagreement")}
                    </ButtonComponent>
                  </>
                ) : null}
              </StepContent>
            </Step>
          )
        )}
      </Stepper>
    </Box>
  );
}
